import { Button } from "@circleco/compass/components/Button";
import type { DataTableColumnDef } from "@circleco/compass/components/DataTable";

import { t } from "@/i18n-js/instance";

import { MemberCell } from "./MemberCell";
import type { MemberEntry } from "./types";

export const createColumns = (
  onRemove: (id: number | string) => void,
): DataTableColumnDef<MemberEntry>[] => [
  {
    field: "name",
    header: t("member"),
    width: "minmax(180px, 1fr)",
    enableSorting: false,
    cell: MemberCell,
  },
  {
    field: "actions",
    header: " ",
    width: "100px",
    enableSorting: false,
    cell: ({ row }: { row: { original: MemberEntry } }) => (
      <div className="invisible flex w-full justify-end group-hover:visible">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onRemove(row.original.id)}
        >
          {t("remove")}
        </Button>
      </div>
    ),
  },
];
